export default __webpack_public_path__ + "static/media/pieczatka7.76fd4897.gif";